(() => {
  const button = document.querySelector('[data-product-back-to-top]');

  if (!button || button.dataset.initialized === 'true') return;

  button.dataset.initialized = 'true';

  const threshold = Number(button.dataset.scrollThreshold) || 400;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let framePending = false;

  const updateVisibility = () => {
    const visible = window.scrollY >= threshold;

    button.classList.toggle('is-visible', visible);
    button.setAttribute('aria-hidden', String(!visible));
    button.tabIndex = visible ? 0 : -1;
  };

  const onScroll = () => {
    if (framePending) return;

    framePending = true;
    window.requestAnimationFrame(() => {
      framePending = false;
      updateVisibility();
    });
  };

  button.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: reduceMotion.matches ? 'auto' : 'smooth'
    });
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  updateVisibility();
})();
